import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { Accordion } from 'semantic-ui-react';
import formatNumber from 'helpers/formatNumber';

const SimpleAccordion = ({ data, activeIndex }) => {
  return (
    <Accordion
      style={{
        marginBottom: '10px',
      }}
    >
      <Accordion.Title
        active
        index={activeIndex}
        className="accordion__container"
      >
        <span className="accordion__label">{data?.label}</span>
        <span className="meta">{formatNumber(data?.value)} RWF</span>
      </Accordion.Title>
      {data?.subs?.map(
        item =>
          item && (
            <Accordion.Content
              key={item?.label}
              active
              className="accordion__item"
            >
              <span>{item?.label}</span>
              <span>{formatNumber(item?.value)} RWF</span>
            </Accordion.Content>
          ),
      )}
    </Accordion>
  );
};

SimpleAccordion.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  activeIndex: PropTypes.number.isRequired,
};

export default SimpleAccordion;
